
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appointment",
      function () {
        return require("private-next-pages/appointment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/appointment"])
      });
    }
  